import styled from 'styled-components';

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 3.6rem;

  @media (max-width: 426px) {
    padding: 0 1.6rem;
  }
`;

export const ContainerBackButton = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
`;